import { NarrativeCards } from './NarrativeCards';

export default NarrativeCards;
